import React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { type ThunkDispatch } from "redux-thunk";
import { showDialog } from "../../Actions/Dialogs/DialogActions";
import { OKOptionButton } from "../../Common/Buttons/Button";
import UnescapedContent from "../../Common/Misc/UnescapedContent";
import { subscribeToOption, unsubscribeFromOption } from "../../Utilities/Platform/Options/Options";

const connector = connect();

type Props = ConnectedProps<typeof connector> & {
    dispatch: ThunkDispatch<any, any, any>;
};

type State = {
    message: string;
};

export class TeamMessage extends React.Component<Props, State> {
    public state = {
        message: "",
    };

    public componentDidMount(): any {
        const message = subscribeToOption("team_message", this.handleUpdate);

        this.setState({
            message,
        });
    }

    public componentWillUnmount(): void {
        unsubscribeFromOption("team_message", this.handleUpdate);
    }

    public handleUpdate = (option: "team_message", newValue: string): void => {
        if(option !== "team_message") {
            return;
        }

        this.setState({
            message: newValue,
        });
    };

    public handleClick = (e: React.MouseEvent<HTMLDivElement>): void => {
        // If team message is not set, ignore
        if(!this.state.message) {
            return;
        }

        // Check to see if click was inside an Anchor tag
        if(e.target instanceof Element && e.target.closest("a")) {
            return;
        }

        const options = [ OKOptionButton ];

        this.props.dispatch(showDialog(
            "Team Message",
            <UnescapedContent style={{ maxWidth: "500px" }}>{this.state.message}</UnescapedContent>,
            "information",
            options
        ));

        e.stopPropagation();
    };

    public render(): React.ReactNode {
        return (
            <div
                className="header-item team-message"
                onClick={this.handleClick}
            >
                <UnescapedContent>{this.state.message}</UnescapedContent>
            </div>
        );
    }
}

export default connector(TeamMessage);
